import api from "./api";

class TimesheetManager {

    create(data:any) {
        return api.post(`/timesheet`, data)
    }

    update(id:string|number, data:any) {
        return api.put(`/timesheet/${id}/`, data)
    }

    weeklyTimesheet(search:any = {}) {
        return api.get(`/weeklytimesheet`, {params: search})
    }

    monthlyResponsibleTimesheet(search:any = {}) {
        return api.get(`/monthly_responsible_timesheet`, {params: search})
    }

}

const timesheetManager = new TimesheetManager()

export default timesheetManager
